var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotSubjectFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.15 26.1H33.9v-4.55H14.15ZM24 45q-4.35 0-8.175-1.65Q12 41.7 9.15 38.85 6.3 36 4.65 32.175 3 28.35 3 24q0-4.4 1.65-8.225Q6.3 11.95 9.15 9.1 12 6.25 15.825 4.6 19.65 2.95 24 2.95q4.4 0 8.225 1.65Q36.05 6.25 38.9 9.1q2.85 2.85 4.5 6.675Q45.05 19.6 45.05 24q0 4.35-1.65 8.175Q41.75 36 38.9 38.85q-2.85 2.85-6.675 4.5Q28.4 45 24 45Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSubjectFill);
export default __webpack_public_path__ + "static/media/not_subject_fill.a34989741a9c58a5ff32530f50d2709f.svg";
export { ForwardRef as ReactComponent };